import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { Box, IconButton, Rating, Stack, Typography } from "@mui/material";
import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useNavigate } from "react-router-dom";
import { CURRENCY } from "../../lib/variables";
import GlobalButton from "../button";
import AddToCartButton from "../cartButton";
import ShinyChip from "../shinyChip";
import "./style.css";
import { useSelector } from "react-redux";

const ProductCard = ({
  cardData,
  colorName,
  cardStyleProps,
  showCardButton = true,
}) => {
  const navigate = useNavigate();
  const { currentLanguage } = useSelector((state) => state.translationReducer);


  const isDiscount = cardData.discount > 0 ? true : false;
  const productPrice =
    cardData.discount > 0 ? cardData.discount : cardData.price;
  let isSizes = cardData?.size?.length === 0;
  let isColors = cardData?.color?.length === 0;
  let isSizesWithColors = cardData?.sizeWithColor?.length === 0;
  let isWeight = cardData?.weigth?.length === 0;

  let isOutOfStock = false;
  let isVariation = false;

  if (
    !isSizes ||
    !isColors ||
    !isSizesWithColors ||
    !isWeight ||
    cardData.type === "Package"
  ) {
    isVariation = true;
  }

  if (
    isSizes &&
    isColors &&
    isSizesWithColors &&
    isWeight &&
    cardData?.quantity === 0
  ) {
    isOutOfStock = true;
  }

  if (!isSizes) {
    isOutOfStock = cardData?.size?.every((itemmmm) => itemmmm.quantity === 0);
  }

  if (!isWeight) {
    isOutOfStock = cardData?.weigth?.every((itemmmm) => itemmmm.quantity === 0);
  }

  if (!isColors) {
    isOutOfStock = cardData?.color?.every((itemmmm) => itemmmm.quantity === 0);
  }

  if (!isSizesWithColors) {
    outerLoop: for (
      let index = 0;
      index < cardData.sizeWithColor?.length;
      index++
    ) {
      for (
        let jindex = 0;
        jindex < cardData.sizeWithColor[index].colors?.length;
        jindex++
      ) {
        if (cardData.sizeWithColor[index].colors[jindex].quantity > 0) {
          isOutOfStock = false;
          break outerLoop;
        } else {
          isOutOfStock = true;
        }
      }
    }
  }

  return (
    <Box
      component="a"
      // href={`http://localhost:3002/e-commerce/${dashName}`}
      onClick={() => {
        navigate(`/product/${cardData.productUrl}`);
      }}
      sx={{
        textDecoration: "none",
        position: "relative",
        overflow: "hidden",
        cursor: "pointer",
        ...cardStyleProps,
        "&:hover .card-button": {
          bottom: "15px",
          transform: "translateY(0)",
        },
      }}
    >
      <Box
        position="relative"
        overflow="hidden"
        border={"1px solid"}
        borderColor={"#7922d8"}
        borderRadius={2}
      >
        {cardData?.type === "Package" && <ShinyChip />}

        <Box
          height={{ xs: 170, sm: 230 }}
          borderRadius={2}
          bgcolor="text.white"
          overflow="hidden"
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          // padding={2}
        >
          <Box
            height={"100%"}
            width={"100%"}
            borderRadius={2}
            overflow={"hidden"}
            bgcolor="text.white"
            position={"relative"}
          >
            <Carousel
              showArrows
              infiniteLoop
              showIndicators={false}
              showStatus={false}
              showThumbs={false}
              renderArrowPrev={(clickHandler, hasPrev) => {
                return (
                  <IconButton
                    sx={{
                      border: "1px solid #ccc",
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                      padding: "3px",
                      position: "absolute",
                      top: "40%",
                      left: "5px",
                      zIndex: 10,
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      "&:hover": {
                        boxShadow: 2,
                        backgroundColor: "#fff",
                      },
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      clickHandler(e);
                    }}
                  >
                    <KeyboardArrowLeft sx={{ fontSize: "20px" }} />
                  </IconButton>
                );
              }}
              renderArrowNext={(clickHandler, hasNext) => {
                return (
                  <IconButton
                    sx={{
                      border: "1px solid #ccc",
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                      padding: "3px",
                      position: "absolute",
                      top: "40%",
                      right: "5px",
                      zIndex: 10,
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      "&:hover": {
                        boxShadow: 2,
                        backgroundColor: "#fff",
                      },
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      clickHandler(e);
                    }}
                  >
                    <KeyboardArrowRight sx={{ fontSize: "20px" }} />
                  </IconButton>
                );
              }}
            >
              {cardData?.images?.map((imageee) => {
                return (
                  <Box
                    component={"img"}
                    src={imageee}
                    // onError={(e) => {
                    //   e.target.onerror = null;
                    //   e.target.src = appLogo.dashboardLogo;
                    // }}
                    sx={{
                      height: { xs: 170, sm: 230 },
                      aspectRatio: 16 / 9,
                      width: "100%",
                      objectFit: "contain",
                      loading: "lazy",
                    }}
                  />
                );
              })}
            </Carousel>
            {/* <img
              src={cardData?.coverImage}
              alt={cardData.name}
              width="100%"
              height="100%"
              style={{ objectFit: "contain" }}
              loading="lazy"
            /> */}
          </Box>
        </Box>
        {showCardButton && (
          <Box
            className="card-button"
            sx={{
              position: "absolute",
              bottom: "-50px",
              left: 10,
              right: 10,
              transform: "translateY(50%)",
              transition: "bottom 0.3s ease, transform 0.3s ease",
              zIndex: 999,
              textAlign: "center",
            }}
          >
            {isVariation ? (
              <GlobalButton
                btnText="View Detail"
                styleProps={{ width: "100%" }}
                handleClickBtn={() =>
                  navigate(`/product/${cardData.productUrl}`)
                }
              />
            ) : (
              <AddToCartButton product={cardData} />
            )}
          </Box>
        )}
      </Box>

      <Box p={0.5} textAlign="center">
        {cardData.type !== "Food" && cardData.weigth?.length === 0 && (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
          >
            <Typography fontSize="1.125rem" color="text.seaGreen">
              {CURRENCY} {productPrice}
            </Typography>
            {isDiscount && (
              <Typography
                fontSize="1rem"
                color="text.coolGrey"
                sx={{ textDecoration: "line-through" }}
              >
                {CURRENCY} {cardData.price}
              </Typography>
            )}
          </Stack>
        )}

        {cardData.type === "Food" && cardData.weigth?.length > 0 && (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
          >
            <Typography fontSize="1.125rem" color="text.seaGreen">
              {CURRENCY} {cardData.weigth[0].price} | {cardData.weigth[0].name[currentLanguage]}
            </Typography>
          </Stack>
        )}

        <Typography fontSize="1.25rem" color={colorName || "text.white"} noWrap>
          {cardData.name[currentLanguage]}
        </Typography>
        <Rating
          name="size-medium"
          size="small"
          value={cardData?.rating}
          readOnly
        />
      </Box>
    </Box>
  );
};

export default React.memo(ProductCard);
